import React from 'react'

const RenderStyles = (props) => props.styles.map((value, index) => <style key={index} dangerouslySetInnerHTML={{__html: value}} />)

export default RenderStyles